<template>
  <div>
    <title-header title='安全中心'></title-header>
    <div class='safe-item' @click='gotoSetPayPwd'>
      <span>支付密码设置/修改</span>
      <van-icon name="arrow" size='20' />
    </div>
    <div class='safe-item' @click='gotoChangePhone'>
      <span>修改手机号</span>
      <van-icon name="arrow" size='20' />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      //前往设置支付密码
      gotoSetPayPwd() {
        this.$router.push({
          name: 'payPwd'
        })
      },
      //前往修改手机号
      gotoChangePhone() {
        this.$router.push({
          name: 'changePhone'
        })
      }
    }
  }
</script>
<style scoped lang='scss'>
  .safe-item{
    display: flex;
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;
    justify-content: space-between;
    align-items: center;
  }
</style>